import { ReminderApiBody } from 'oneminuteaday-common';
import { apiInstance } from './apiInstance';
export const addReminder = async (body: ReminderApiBody) =>
  await apiInstance
    .post<{ requireUserLogin: boolean }>('reminder/add', body)
    .then((response) => response.data);
